import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { nagoyatvPageMeta, nagoyatvSchema } from 'components/common/schema'
import Template from 'components/cases/nagoyatv'

const Nagoyatv: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...nagoyatvPageMeta} />
      <JsonLd data={nagoyatvSchema} />
      <Template />
    </>
  )
}

export default Nagoyatv
